module.exports = __webpack_public_path__ + "img/second.26b99d2.png";